import { render } from "./userFinanceView.vue?vue&type=template&id=625d78eb&scoped=true"
import script from "./userFinanceView.vue?vue&type=script&lang=js"
export * from "./userFinanceView.vue?vue&type=script&lang=js"

import "./userFinanceView.vue?vue&type=style&index=0&id=625d78eb&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625d78eb"]])

export default __exports__